import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function StorySection() {
  return <section className="py-24 px-4 bg-[#0C0F17] relative overflow-hidden" data-id="element-256">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 opacity-15" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/eLmjAW7mZnKJmLFm3ofES4/489e2d93-e11a-418b-bd39-15e587bdc942.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-257" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0C0F17]/90 via-[#0C0F17]/95 to-[#0C0F17]" data-id="element-258" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-259">
        {/* Main Story */}
        <div className="mb-20" data-id="element-260">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-[#111522] p-8 md:p-12 rounded-2xl shadow-xl border border-[#CFA86A]/20 relative overflow-hidden" data-id="element-261">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#CFA86A] to-[#5B86FF]" data-id="element-262" />
            <Quote className="absolute top-8 left-8 text-[#CFA86A] w-16 h-16 -z-0 opacity-10" data-id="element-263" />

            <div className="relative z-10" data-id="element-264">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#F7F5F2] mb-6" data-id="element-265">
                Ana decidió hablar y salvó su vida emocional
              </h2>
              <div className="prose prose-lg text-[#F7F5F2]/80 font-light leading-relaxed" data-id="element-266">
                <p className="mb-4" data-id="element-267">
                  Ana llevaba meses sintiendo un vacío con su pareja. A simple
                  vista todo "seguía bien": trabajo estable, una casa, amigos.
                  Pero algo dentro de ella estaba en tensión. Hacía lecturas
                  rápidas por las mañanas y la misma estructura aparecía: miedo
                  a expresar necesidades. No era una predicción —era un espejo.
                </p>
                <p className="mb-4" data-id="element-268">
                  El miedo la había paralizado. Tres semanas después, armada con
                  la claridad que le dio su lectura, Ana tuvo una conversación
                  honesta. No terminó la relación. Reescribió cómo se cuidaban.
                  Recuperó su voz. Esa decisión cambió su vida: menos
                  resentimiento, más presencia, más conexión real.
                </p>
                <p className="font-serif italic text-[#CFA86A] text-xl mt-6" data-id="element-269">
                  Esa es la diferencia entre reaccionar y decidir.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Mini Cases */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-270">
          {[{
          name: 'Diego',
          story: 'Dejó un empleo que lo agotaba. Planificó y hoy trabaja con más propósito.'
        }, {
          name: 'Vero',
          story: 'Entendió que su crush era una señal de soledad y trabajó su plenitud; tiempo después encontró una relación recíproca.'
        }, {
          name: 'Andrea',
          story: 'Delegó responsabilidades y recuperó salud; sus ingresos se normalizaron con más claridad mental.'
        }].map((item, index) => <motion.div key={item.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="bg-[#111522]/60 p-6 rounded-xl border border-[#CFA86A]/20 hover:border-[#CFA86A]/40 transition-colors duration-300" data-id="element-271">
              <h3 className="font-serif font-bold text-xl text-[#F7F5F2] mb-2" data-id="element-272">
                {item.name}
              </h3>
              <p className="text-[#F7F5F2]/70 text-sm leading-relaxed" data-id="element-273">
                {item.story}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}